
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State, Getter } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";

import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";
import SmallBadge from "@/components/properties/SmallBadge.vue";
import ModalJobsFair from "@/views/apps/jobsfair/ModalJobsFair.vue";

@Component({
  components: {
    PaginationMiniComponent,
    SmallBadge,
    ModalJobsFair,
  },
  filters,
})
export default class JobsFairList extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionJobFairHistoryList", { namespace: "job" })
  private actionJobFairHistoryList: any;
  @Action("actionPaginationJobFairHistory", { namespace: "job" })
  private actionPaginationJobFairHistory: any;

  // STATE
  @State("locale")
  private locale: string;
  @State("job_fair_history", { namespace: "job" })
  private job_fair_history: any;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* WATCHER */

  @Watch("locale")
  private onLocaleChanged() {
    this.actionJobFairHistoryList({
      params: null,
      success: (response: any) => {},
      fail: (response: any) => {},
    });
  }

  private created() {}

  private detailCompany(jobfair: any) {
    const param = {
      job_id: jobfair.id,
    };
    this.$router.push({ name: "jobsFairDetail", params: param });
  }
}
